import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_TYPE,
  COLUMN_AFFILIATE,
  COLUMN_APPLICATION,
  COLUMN_APPROVERS,
  COLUMN_CAMPAIGNS,
  COLUMN_NETWORK,
  COLUMN_PLATFORM,
  COLUMN_CLUSTER,
  COLUMN_AMOUNT,
  COLUMN_ORIGINAL_AMOUNT,
  COLUMN_CURRENCY,
  COLUMN_STATUS,
  COLUMN_PERIOD,
  COLUMN_REASON,
  COLUMN_UPDATED_DATE,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
} from 'scenes/SpendAdjustments/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_PERIOD,
    COLUMN_AFFILIATE,
    COLUMN_STATUS,

    COLUMN_APPLICATION,
    COLUMN_NETWORK,
    COLUMN_CLUSTER,
    COLUMN_PLATFORM,
    COLUMN_CAMPAIGNS,
    COLUMN_ORIGINAL_AMOUNT,
    COLUMN_AMOUNT,
    COLUMN_CURRENCY,
    COLUMN_TYPE,
    COLUMN_REASON,
    COLUMN_APPROVERS,
    COLUMN_UPDATED_DATE,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
